import { useState } from 'react';
import SpeedIcon from '@mui/icons-material/Speed';
import RouterIcon from '@mui/icons-material/Router';
import SimCardIcon from '@mui/icons-material/SimCard';
import FourGMobiledataIcon from '@mui/icons-material/FourGMobiledata';
import WifiIcon from '@mui/icons-material/Wifi';
import TtyIcon from '@mui/icons-material/Tty';
import { Box, Divider, IconButton, Typography } from '@mui/material';
import MenuItem from './MenuItem';
import MenuIcon from '@mui/icons-material/Menu';
import CloseIcon from '@mui/icons-material/Close';
import { NavLink, useNavigate } from 'react-router-dom';
import logo from 'assets/images/logo.png';
function Menu() {
  const [show, setShow] = useState(false);
  const navigate = useNavigate()
  return (
    <>
      <Box
        className="container"
        sx={{
          display: 'flex',
          flexDirection: { xs: 'row', md: 'row-reverse' },

          alignItems: 'center',
          gap: 8,
          margin: 'auto',
          height: 65,
        }}>
        <Box
          sx={{
            display: { xs: 'none', lg: 'flex' },
            flexDirection: 'column',
            alignItems: 'center',
          }}>
          <Typography color="text.secondary">تماس رایگان</Typography>
          <Typography color="primary.main">0989895525</Typography>
        </Box>
        <Box
          sx={{
            display: { xs: 'none', md: 'flex' },
            flexDirection: 'row',
            alignItems: 'center',
            gap: 4,
            height: 65,
            flexGrow: 1,
          }}>
          <NavLink
            to={'/fiber'}
            style={({ isActive }) =>
              isActive ? { color: '#605cb8',borderTop:'2px solid #605cb8',borderRadius:'8px' } : { color: '#474747' }
            }>
            <MenuItem>
              <div style={{display:'flex',alignItems:'center',gap:4}}>
              <SpeedIcon />
              <Typography component={'div'}  fontWeight={600} sx={{mt:0.5,fontSize:'0.780rem'}}>
                فیبر
              </Typography>
              </div>
            </MenuItem>
          </NavLink>
          <NavLink
            to={'/adsl'}
            style={({ isActive }) =>
              isActive ? { color: '#605cb8',borderTop:'2px solid #605cb8',borderRadius:'8px' } : { color: '#474747' }
            }>
            <MenuItem>
            <div style={{display:'flex',alignItems:'center',gap:4}}>
              <RouterIcon />
              <Typography component={'div'} fontWeight={600} sx={{mt:1,fontSize:'0.780rem'}}>
                Adsl+2
              </Typography>
              </div>
            </MenuItem>
          </NavLink>
          <NavLink
            to={'/td-lte'}
            style={({ isActive }) =>
              isActive ? { color: '#605cb8',borderTop:'2px solid #605cb8',borderRadius:'8px' } : { color: '#474747' }
            }>
            <MenuItem>
            <div style={{display:'flex',alignItems:'center',gap:4}}>
              <SimCardIcon />
              <Typography component={'div'} fontWeight={600} sx={{mt:1,fontSize:'0.780rem'}}>
                TD-LTE
              </Typography>
              </div>
            </MenuItem>
          </NavLink>

          <NavLink
            to={'/4g'}
            style={({ isActive }) =>
              isActive ? { color: '#605cb8',borderTop:'2px solid #605cb8',borderRadius:'8px' } : { color: '#474747' }
            }>
            <MenuItem>
            <div style={{display:'flex',alignItems:'center',gap:4}}>
              <FourGMobiledataIcon />
              <Typography component={'div'}  fontWeight={600} sx={{mt:0.5,fontSize:'0.780rem'}}>
                نسل چهارم
              </Typography>
              </div>
            </MenuItem>
          </NavLink>

          <NavLink
            to={'/OWA'}
            style={({ isActive }) =>
              isActive ? {color: '#605cb8',borderTop:'2px solid #605cb8',borderRadius:'8px'} : { color: '#474747' }
            }>
            <MenuItem>
            <div style={{display:'flex',alignItems:'center',gap:4}}>
              <WifiIcon />
              <Typography component={'div'}  fontWeight={600} sx={{mt:1,fontSize:'0.780rem'}}>
                OWA
              </Typography>
              </div>
            </MenuItem>
          </NavLink>
          <NavLink
            to={'/asia-tell'}
            style={({ isActive }) =>
              isActive ? { color: '#605cb8',borderTop:'2px solid #605cb8',borderRadius:'8px' } : { color: '#474747' }
            }>
            <MenuItem>
            <div style={{display:'flex',alignItems:'center',gap:4}}>
              <TtyIcon />
              <Typography component={'div'} fontWeight={600} sx={{mt:0.5,fontSize:'0.780rem'}}>
                آسیاتل
              </Typography>
              </div>
            </MenuItem>
          </NavLink>
        </Box>

        <Box
          sx={{
            display: { xs: 'flex', md: 'none' },
            height: '100%',
            alignItems: 'center',
          }}>
          <IconButton onClick={() => setShow(!show)}>
            {show ? (
              <CloseIcon sx={{ color: 'primary.main' }} />
            ) : (
              <MenuIcon sx={{ color: 'primary.main' }} />
            )}
          </IconButton>
        </Box>

        <Box sx={{ marginLeft: { xs: 'auto', md: '0px' } }}>
          <img src={logo} onClick={()=>navigate('/')} style={{cursor:'pointer'}}/>
        </Box>
      </Box>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          width: show ? '100%' : '0',
          background: 'white',
          position: 'absolute',
          overflowX: 'hidden',
          transition: 'all 500ms',
          boxShadow: 1,
          height: '100vh',
        }}>
        <Box
          sx={{ display: 'flex', gap: 2, py: 5 }}
          onClick={() => setShow(false)}>
          <NavLink to={'/fiber'}>
            <MenuItem>
              <SpeedIcon />
              <Typography component={'div'} variant="caption ">
                Fiber
              </Typography>
            </MenuItem>
          </NavLink>
        </Box>
        <Divider sx={{ width: '80%' }} />
        <Box
          sx={{ display: 'flex', gap: 2, py: 5 }}
          onClick={() => setShow(false)}>
          <NavLink to={'/adsl'}>
            <MenuItem>
              <RouterIcon />
              <Typography component={'div'} variant="caption ">
                Adsl+2
              </Typography>
            </MenuItem>
          </NavLink>
        </Box>
        <Divider sx={{ width: '80%' }} />
        <Box
          sx={{ display: 'flex', gap: 2, py: 5 }}
          onClick={() => setShow(false)}>
          <NavLink to={'/td-lte'}>
            <MenuItem>
              <SimCardIcon />
              <Typography component={'div'} variant="caption ">
                TD-LTE
              </Typography>
            </MenuItem>
          </NavLink>
        </Box>
        <Divider sx={{ width: '80%' }} />
        <Box
          sx={{ display: 'flex', gap: 2, py: 5 }}
          onClick={() => setShow(false)}>
          <NavLink to={'/4g'}>
            <MenuItem>
              <FourGMobiledataIcon />
              <Typography component={'div'} variant="caption ">
                4G
              </Typography>
            </MenuItem>
          </NavLink>
        </Box>
        <Divider sx={{ width: '80%' }} />
        <Box
          sx={{ display: 'flex', gap: 2, py: 5 }}
          onClick={() => setShow(false)}>
          <NavLink to={'/OWA'}>
            <MenuItem>
              <WifiIcon />
              <Typography component={'div'} variant="caption ">
                OWA
              </Typography>
            </MenuItem>
          </NavLink>
        </Box>
        <Divider sx={{ width: '80%' }} />
        <Box
          sx={{ display: 'flex', gap: 2, py: 4 }}
          onClick={() => setShow(false)}>
          <NavLink to={'/asia-tell'}>
            <MenuItem>
              <TtyIcon />
              <Typography component={'div'} variant="caption ">
                آسیاتل
              </Typography>
            </MenuItem>
          </NavLink>
        </Box>
        <Divider sx={{ width: '80%' }} />
      </Box>
    </>
  );
}

export default Menu;
